<div class="row mt-4">
    <div class="col-12">
        <div class="form-inline">
            <span class="badge badge-warning badge-light-warning">
                <span class="material-icons">
                    military_tech
                </span>
            </span>
            <h4 class="mt-2">Mi estatus</h4>
        </div>
    </div>
</div>

<div class="row mt-2">
    <div class="col-12 d-flex justify-content-end">
        <div class="form-inline">
            <span class="material-icons cursor-pointer text-info" *ngIf="togglePeriod"
                (click)="switchDisplayIndicators()">
                toggle_on
            </span>
            <span class="material-icons cursor-pointer text-success" *ngIf="!togglePeriod"
                (click)="switchDisplayIndicators()">
                toggle_off
            </span>
        </div>
        <div class="btn-group">
            <div class="btn-group" role="group" *ngIf="togglePeriod">
                <button class="btn btn-outline-info" (click)="getLastWeek()">
                    <span class="material-icons">
                        arrow_back
                    </span>
                </button>
                <button class="btn btn-outline-info d-flex align-items-center" (click)="getCurrentWeek()">
                    <span>
                        Semana:
                    </span>
                    {{currentWeek}}
                </button>
                <button class="btn btn-outline-info" (click)="getNextWeek()">
                    <span class="material-icons">
                        arrow_forward
                    </span>
                </button>
            </div>
            <div class="btn-group" role="group" *ngIf="!togglePeriod">
                <button class="btn btn-outline-info" (click)="getLastMonth()">
                    <span class="material-icons">
                        arrow_back
                    </span>
                </button>
                <button class="btn btn-outline-info d-flex align-items-center" (click)="getCurrentMonth()">
                    <span>
                        Mes:
                    </span>
                    {{returnMonthFormat(currentMonth)}}
                </button>
                <button class="btn btn-outline-info" (click)="getNextMonth()">
                    <span class="material-icons">
                        arrow_forward
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>
<div class="row match-height mt-2 mb-5" *ngIf="!isLoading">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-12 mt-1" *ngFor="let indicator of indicators">
        <div class="card mb-0 pb-0" #containerRef>
            <div class="card-header">
                <h4 class="card-title indicator-name" [ngbTooltip]="indicator.indicator">
                    {{ indicator.indicator }}
                </h4>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <google-chart [type]="'Gauge'" [width]="100" [height]="100"
                        [data]="[['Resultado', (mesurements[indicator.id!] ? mesurements[indicator.id!].result : 0)]]"
                        [options]="mesurements[indicator.id!].gaugeChartOptions"></google-chart>
                    <p>M: {{ getFormat(indicator.type, indicator.goal) }}</p>
                    <p>R: {{getFormat(indicator.type, mesurements[indicator.id!] ?
                        mesurements[indicator.id!].result
                        : 0)}}</p>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner></ngx-spinner>